// @i18n-ignore-file
import { NEW_HOME_PAGE_EXPERIMENT_COOKIE_KEY } from '@src/quince-site-common/src/constants/experimentCookies'

import { IPageExperiment } from '../pageExperiments.types'

const PAGE_EXPERIMENTS = {
  NEW_HOME_PAGE: {
    name: 'new-home-page',
    pageExpCookie: NEW_HOME_PAGE_EXPERIMENT_COOKIE_KEY,
    buckets: {
      control: 'control',
      show1: 'show1',
      show2: 'show2',
    },
  },
} satisfies Record<string, IPageExperiment>

export default PAGE_EXPERIMENTS
